import { callApiV2 } from "@/lib/config/Api";
import {
	ConfirmPasswordCustomerRes,
	CustomerJson,
	CustomerJsonAddEdit,
	NotificationJson,
	NotificationProps,
	PasswordAddEditJson,
	SenderCustomerAddEditJson,
	TypeAbleChange,
	VerifyCustomerAddEditJson,
} from "@/types/Customer.type";

const SENDER_TYPE = {
	CHANGE_CONTACT: 10, //thay đổi email và phone
	CHANGE_USERNAME: 11, //update username
	VERIFY: 12, //verify
	PROFILE: 13,
	NEWSLETTER: 6, //đăng ký nhận tin
};

export async function notification(data: NotificationProps) {
	const res = await callApiV2<NotificationJson[]>(
		"/customers/public/notification",
		"post",
		{
			data: data,
		}
	);
	return res;
}

export async function checkIsCanUpdate(
	customer: CustomerJson,
	type: TypeAbleChange
) {
	let body: SenderCustomerAddEditJson = {
		type: 0,
		contact_type: undefined,
		account_id: undefined,
		non_code: 1,
		user_name: undefined,
	};
	switch (type) {
		case "USER_NAME":
			body = {
				...body,
				type: SENDER_TYPE.CHANGE_USERNAME,
			};
			break;
		case "EMAIL":
			body = {
				...body,
				type: SENDER_TYPE.CHANGE_CONTACT,
				contact_type: "email",
				account_id: customer.email,
			};

			break;
		case "PHONE":
			body = {
				...body,
				type: SENDER_TYPE.CHANGE_CONTACT,
				contact_type: "phone",
				account_id: customer.phone,
			};
			break;
		case "INFO":
			body = {
				...body,
				type: SENDER_TYPE.PROFILE,
				account_id: customer.id.toString(),
			};
			break;
		default:
			break;
	}
	const response = await callApiV2<boolean>("/customers/checksender", "post", {
		data: body,
	});
	return response;
}

export async function verifyPassword(password: string) {
	const response = await callApiV2<ConfirmPasswordCustomerRes>(
		`/users/customer/checkpassword`,
		"post",
		{ data: { password: password } }
	);

	return response;
}

export async function changePassword(body: PasswordAddEditJson) {
	const response = await callApiV2<boolean>(
		`/users/customer/changepassword`,
		"put",
		{ data: body }
	);
	return response;
}

export async function updateInfo(id: number, data: CustomerJsonAddEdit) {
	const response = await callApiV2<CustomerJson>(
		`/customers/${id}/customer`,
		"put",
		{
			data: data,
		}
	);
	return response;
}

export async function changeUsername(newUsername: string, codeVerify: string) {
	const response = await callApiV2<boolean>(`/customers/sender`, "post", {
		data: {
			type: SENDER_TYPE.CHANGE_USERNAME,
			user_name: newUsername,
			code: codeVerify,
		},
	});
	return response;
}

export async function verifyOtp(data: VerifyCustomerAddEditJson) {
	const response = await callApiV2<boolean>("/customers/verify", "post", {
		data: data,
	});
	return response;
}

export async function getOtp(data: SenderCustomerAddEditJson) {
	const response = await callApiV2<any>("/customers/sender", "post", {
		data: data,
	});

	return response;
}
